import {initUserInfo, UserInfoModel} from "../../models/UserInfoModel";

const types = {
    USER_PENDING_FETCH: "USER_PENDING_FETCH",
    USER_FETCH_SUCCESS: "USER_FETCH_SUCCESS",
    USER_FETCH_FAILURE: "USER_FETCH_FAILURE"
}

export const actions = {
    initUserInfo: async (dispatch: any) => {
        dispatch({type: types.USER_PENDING_FETCH})
        const json: UserInfoModel = initUserInfo()
        if (json === undefined || json === null) {
            dispatch({type: types.USER_FETCH_FAILURE})
        } else {
            if (json.nationalId !== undefined) {
                dispatch({
                    type: types.USER_FETCH_SUCCESS,
                    payload: json
                })
            }

        }
    },
    setUserInfo: async (dispatch: any, request: UserInfoModel) => {
        dispatch({type: types.USER_PENDING_FETCH})
        const json: UserInfoModel = request
        if (json === undefined || json === null) {
            dispatch({type: types.USER_FETCH_FAILURE})
        } else {
            dispatch({
                type: types.USER_FETCH_SUCCESS,
                payload: json
            })
        }
    }
}

const initialState = {
    userInfo: initUserInfo(),
    isFetching: false
};

export const userInfoReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case types.USER_FETCH_SUCCESS:
            return {
                ...state,
                userInfo: action.payload,
                isFetching: false
            };
        case types.USER_FETCH_FAILURE:
            return {
                ...state,
                isFetching: false
            };
        case types.USER_PENDING_FETCH:
            return {
                ...state,
                isFetching: true
            }
        default:
            return state;
    }
}